<template>
    <div class="watermark-wrapper">
        <div class="watermark" ref="watermark"></div>
        <canvas id="myCanvas"></canvas>
        <canvas id="canvas2"></canvas>
    </div>
</template>

<script>
    export default {
        data () {
            return {

            }
        },
        methods: {
            initWaterMark (imgPreviewMark) {

                let htmlFontSize = Number(document.getElementsByTagName('html')[0].style.fontSize.split('px')[0])
                let visible_h = document.getElementById('app').clientWidth
                // var rHeight = this.$refs.watermark.offsetHeight
                // var rWidth = this.$refs.watermark.offsetWidth
                // var rDistance = Math.sin( -30 * Math.PI / 180) * rHeight * Math.cos(-30 * Math.PI / 180)

                var canvas = document.getElementById('myCanvas')
                canvas.width = 200 * visible_h / 375
                canvas.height = 200 * visible_h / 375
                var ctx = canvas.getContext('2d')

                ctx.clearRect(0, 0, canvas.width, canvas.height)
                // ios device don't support rem
                ctx.font = 0.426 * htmlFontSize + 'px' + ' Noto Sans CJK SC Light, PingFangSC, PingFangSC-Regular ,Microsoft Himalaya'


                ctx.translate(100 * visible_h / 375, 100)
                ctx.rotate(-30 * Math.PI / 180)
                // ctx.fillStyle = 'rgba(0, 15, 23, .15)'
                ctx.fillStyle = 'rgba(0, 15, 23, .08)'
                ctx.textAlign = 'center'
                ctx.fillText((localStorage.EnName || '') + ' ' + (localStorage.CnName || ''), 0, 0)

                this.$refs.watermark.style.backgroundImage = 'url("' + ctx.canvas.toDataURL() + '")'

                if (imgPreviewMark) {

                    var canvas2 = document.getElementById('canvas2')
                    canvas2.width = 200 * visible_h / 375
                    canvas2.height = 200 * visible_h / 375
                    var ctx2 = canvas2.getContext('2d')

                    ctx2.clearRect(0, 0, canvas2.width, canvas2.height)
                    // ios device don't support rem
                    ctx2.font = 0.426 * htmlFontSize + 'px' + ' Noto Sans CJK SC Light, PingFangSC, PingFangSC-Regular'

                    ctx2.translate(80, 100)
                    ctx2.rotate(-30 * Math.PI / 180)
                    ctx2.fillStyle = 'rgba(255, 255, 255, 0.3)'
                    ctx2.textAlign = 'center'
                    ctx2.fillText((localStorage.EnName || '') + ' ' + (localStorage.CnName || ''), 0, 0)
                }

                if (imgPreviewMark) {
                    let timer = setTimeout( () => {
                        document.getElementsByClassName('pswp')[0].style.backgroundColor = '#000'
                        document.getElementsByClassName('pswp__bg')[0].style.zIndex = '10'
                        document.getElementsByClassName('pswp__bg')[0].style.pointerEvents = 'none'
                        document.getElementsByClassName('pswp__bg')[0].style.backgroundColor = 'transparent'
                        document.getElementsByClassName('pswp__bg')[0].style.backgroundImage = 'url("' + ctx2.canvas.toDataURL() + '")'

                        document.getElementsByClassName('pswp')[1].style.backgroundColor = '#000'
                        document.getElementsByClassName('pswp__bg')[1].style.zIndex = '10'
                        document.getElementsByClassName('pswp__bg')[1].style.pointerEvents = 'none'
                        document.getElementsByClassName('pswp__bg')[1].style.backgroundColor = 'transparent'
                        document.getElementsByClassName('pswp__bg')[1].style.backgroundImage = 'url("' + ctx2.canvas.toDataURL() + '")'
                        clearTimeout(timer)
                    })

                    this.$refs.watermark.style.backgroundImage = 'unset'
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .watermark {
        position: absolute;
        z-index: 2000;
        top: 0; left: 0;
        bottom: 0; right: 0;
        // background: oldlace;
        // transform: rotate(-30deg);
        pointer-events: none;
    }
    canvas {
        display: none;
        border: 1px solid red;
        position: absolute;
        top: 180px;
        left: 100px;
        z-index: 19;
    }
    // #canvas2 {
    //     display: none;
    // }
</style>


// WEBPACK FOOTER //
// src/components/waterMark.vue